import { ReactNode } from 'react';
import styled from '@emotion/styled';

import { fontSize, spacing, borderRadius } from 'presentations/views/styles';
import { gray05, gray06, white } from 'presentations/views/styles/color';

import TextFieldDatePicker from 'presentations/views/components/atoms/TextFieldDatePicker';
import TextFieldTimePicker from 'presentations/views/components/atoms/TextFieldTimePicker';
import { DateTime } from 'infras/datetime';
import TimePicker from '../../atoms/TimePicker';

export interface Props {
  timeZone: string;
  date: DateTime | null;
  hour?: number | null;
  minute?: number | null;
  isAllday?: boolean;
  children?: ReactNode;
  onSelect?: (datetime: DateTime) => void;
  defaultJustifyContent?: string;
  isDisabled?: boolean;
  isHideToday?: boolean;
  selectable24hour?: boolean;
  minDate?: DateTime | null;
  timePicker?: boolean;
}
export default function Component(props: Props) {
  return (
    <DayBlock
      isAllday={props.isAllday}
      defaultJustifyContent={props.defaultJustifyContent}
    >
      <TextFieldDatePicker
        onSelect={props.onSelect}
        value={props.date}
        buttonPosition="end"
        minDate={props.minDate ? props.minDate.toJSDate() : null}
        inputVariant="filled"
        placeholder="yyyy/MM/dd"
        isHideToday={props.isHideToday}
      />
      {!props.isAllday &&
        (props.timePicker ? (
          <TimePicker
            timeZone={props.timeZone}
            onSelect={props.onSelect}
            date={props.date}
            isDisabled={props.isDisabled}
          />
        ) : (
          <TextFieldTimePicker
            timeZone={props.timeZone}
            onSelect={props.onSelect}
            date={props.date}
            valueHour={props.hour}
            valueMinute={props.minute}
            isDisabled={props.isDisabled}
            selectable24hour={props.selectable24hour}
          />
        ))}
      {props.children}
    </DayBlock>
  );
}

const DayBlock = styled.div<{
  isAllday?: boolean;
  defaultJustifyContent?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ defaultJustifyContent }) =>
    defaultJustifyContent || 'initial'};

  & .MuiFormControl-root {
    width: 94px;
    margin: 0 ${spacing(4)} 0 0;
    background-color: ${white};
  }
  .MuiFilledInput-root.Mui-disabled {
    cursor: pointer;
    background-color: ${gray06};
    padding-right: 0;
    border-radius: ${borderRadius(6)};
  }
  .MuiFilledInput-root:hover,
  .MuiFilledInput-root.Mui-disabled:hover {
    background-color: ${gray05};
  }
  .MuiFilledInput-input {
    cursor: pointer;
    padding: ${spacing(8)};
    font-size: ${fontSize(13)};
  }
  .MuiFilledInput-underline.Mui-disabled:before,
  .MuiFilledInput-underline:after {
    border-bottom: none;
  }
  & .MuiInputAdornment-root {
    display: none;
  }
  .MuiFilledInput-adornedEnd {
    padding-right: 0;
  }

  .MuiFilledInput-root {
    padding-right: 0;
    background-color: ${gray06};
    font-size: ${fontSize(14)};
  }
  .MuiFilledInput-underline:before,
  .MuiFilledInput-underline:after {
    border: none;
  }
`;
